import React, { useState, useEffect, FC } from 'react'
import Icon from '../../Core/Iconography/Icon/Icon'
import Font from '../../Core/Typography/Font/Font'
import {
  PopupContainer,
  PopupBox,
  LabelWrapper,
  IconWrapper,
} from './Popup.styles'
import { PopupProps } from './types'

const Popup: FC<PopupProps> = props => {
  const {
    title,
    label,
    popupCloseHelperFunction,
    popupContainerWidth,
    popupContainerHeight
  } = props

  const [isOpen, setOpen] = useState(true)

  useEffect(() => {
    setTimeout(() => {
      if (!props.removeSelfClose){
        setOpen(false)
        popupCloseHelperFunction && popupCloseHelperFunction(true)
      }
    }, 3000)
  }, [])

  const actionClick = () => {
    const { click } = props
    if (click) click(false)
    setOpen(false)
  }

  if (!isOpen) return null

  return (
    <PopupContainer as='section' popupContainerWidth={popupContainerWidth} popupContainerHeight={popupContainerHeight}>
      <PopupBox alignItems='flex-start' type={!label ? 'error' : props.type}>
        <LabelWrapper>
          {title && <Font tag='h4'>{title}</Font>}
          <Font>{label}</Font>
        </LabelWrapper>
        <IconWrapper data-testid='icon-wrapper' onClick={actionClick}>
          <Icon name='close' size='s' />
        </IconWrapper>
      </PopupBox>
    </PopupContainer>
  )
}

Popup.defaultProps = {
  removeSelfClose: false,
  label: '',
  type: 'success',
}

export default Popup
